<template>
  <div class="createPlayStep">
    <!-- 头部返回 -->
    <div class="backBox">
      <img
        class="pointer"
        @click="returnBack()"
        src="@/assets/thdImg/pages/back.svg"
        alt=""
      />
      <span class="backBox_name">{{
        !backgroundOpacity
          ? !valueRow || activityData.isCopy
            ? "创建活动"
            : "编辑活动"
          : "查看活动"
      }}</span>
    </div>
    <div
      class="formBox"
      :style="backgroundOpacity ? 'height:calc(100vh - 178px)' : ''"
    >
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="0">
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>
      <!-- 活动条件表单设置 -->
      <div class="secondstep">
        <el-form
          :model="ruleForm"
          :rules="rules"
          :disabled="backgroundOpacity"
          ref="ruleForm"
          class="backgroundForm"
          label-width="150px"
        >
          <div class="newsInfo">基本规则</div>
          <el-form-item label="活动名称：" required>
            <el-input
              v-model="ruleForm.activityName"
              maxlength="15"
              show-word-limit
              placeholder="请输入活动名称"
              style="width: 400px"
              :disabled="isStart"
            ></el-input>
          </el-form-item>

          <el-form-item label="活动参与对象：" prop="allowLevel">
            <el-checkbox-group
              v-model="ruleForm.allowLevel"
              @change="checkListchange"
              :disabled="!!valueRow && !isDraftEdit && !activityData.isCopy"
            >
              <el-checkbox label="-1" name="allowLevel">全部</el-checkbox>
              <el-checkbox
                v-for="(item, index) in levelList"
                :key="index"
                :label="index + 1 + ''"
                name="allowLevel"
                :disabled="ruleForm.allowLevel == -1"
                >{{ item }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="活动条件：">
            <!-- 需求更改说写死 -->
            入会后方可参与活动
            <!-- <el-checkbox
              label="入会后方可参与活动"
              v-model="ruleForm.isOpenCard"
              disabled
            ></el-checkbox> -->
          </el-form-item>
          <el-form-item label="活动结束时间：" required>
            <el-date-picker
              v-model="ruleForm.endTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              ref="timeBox"
              style="width: 200px; font-size: 12px"
              :picker-options="pickerOptionsValue"
              :default-time="defaultEndTime"
              :disabled="activityData.isStart"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="活动C端背景图：" required>
            <div class="miniAppPic">
              <div class="top">
                <el-upload
                  class="upload"
                  action="/jd-hd-web/image/upload"
                  :show-file-list="false"
                  :before-upload="beforeUpload"
                  :on-success="handleUpload"
                  :disabled="isStart"
                >
                  <el-button size="mideal" class="returnBtn"
                    >自定义上传</el-button
                  >
                </el-upload>
              </div>
              <div class="bottom">
                <el-image class="elImg" :src="ruleForm.picUrl" fit="contain">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-plus"></i>
                  </div>
                </el-image>
                <div class="tips1">
                  <p>建议上传尺寸：750px * 1550px</p>
                  <p>图片大小：300KB以内</p>
                  <p>格式：jpg、png</p>
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="活动隔离：">
            <el-input
              style="width: 425px;"
              v-model="ruleForm.isolateActivityId"
              placeholder="请填入隔离活动ID，多个用逗号隔开，如1,2,3"
              @input="forceUpdate()"
            ></el-input>
            <div style="color: red;">
              注：输入需隔离的活动，多个需用逗号隔开，设置成功后，若用户在任意一个隔离活动中进行锁权且锁权成功，则无法参与该锁权活动
            </div>
          </el-form-item>
          <div class="newsInfo">参与规则</div>
          <el-form-item label="确权时间：" required>
            <el-date-picker
              v-model="ruleForm.lockStartTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              ref="timeBox"
              style="width: 200px; font-size: 12px"
              :picker-options="lockStartTimeOption"
              :default-time="defaultStartTime"
              @change="(val) => (ruleForm.enterStartTime = val)"
              :disabled="isStart"
            >
            </el-date-picker>
            至
            <el-date-picker
              v-model="ruleForm.lockEndTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              ref="timeBox"
              style="width: 200px; font-size: 12px"
              :picker-options="lockEndTimeOption"
              :default-time="defaultEndTime"
              :disabled="isStart"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="确权积分：" required>
            <el-input
              type="text"
              :maxlength="6"
              v-model="ruleForm.point"
              clearable
              style="width: 200px;"
              @input="(val) => checkputn(val, 'point')"
              :disabled="isStart"
            ></el-input>
            个
          </el-form-item>
          <el-form-item label="下单时间：" required>
            <el-date-picker
              v-model="ruleForm.orderStartTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              ref="timeBox"
              style="width: 200px; font-size: 12px"
              :picker-options="orderStartTimeOption"
              :default-time="defaultStartTime"
              @change="(val) => (ruleForm.finishStartTime = val)"
              :disabled="isStart"
            >
            </el-date-picker>
            至
            <el-date-picker
              v-model="ruleForm.orderEndTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              ref="timeBox"
              style="width: 200px; font-size: 12px"
              :picker-options="orderEndTimeOption"
              :default-time="defaultEndTime"
              :disabled="isStart"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="金额统计规则：">
            <el-radio-group v-model="ruleForm.moneyCountType">
              <el-radio :label="0">按累计</el-radio>
              <el-radio :label="1">按单笔</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            :label="ruleForm.moneyCountType ? '单笔金额满：' : '累计金额满：'"
            required
          >
            <el-input
              type="text"
              :maxlength="6"
              v-model="ruleForm.orderAmt"
              clearable
              style="width: 200px;"
              @input="(val) => checkputn(val, 'orderAmt')"
              :disabled="isStart"
            ></el-input>
            元
          </el-form-item>
          <el-form-item label="确认收货时间：" required>
            <el-date-picker
              v-model="ruleForm.finishStartTime"
              disabled
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              ref="timeBox"
              style="width: 200px; font-size: 12px"
              :default-time="defaultStartTime"
            >
            </el-date-picker>
            至
            <el-date-picker
              v-model="ruleForm.finishEndTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              ref="timeBox"
              style="width: 200px; font-size: 12px"
              :picker-options="finishEndTimeOption"
              :default-time="defaultEndTime"
              :disabled="isStart"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="收货信息录入时间：" required>
            <el-date-picker
              v-model="ruleForm.enterStartTime"
              disabled
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              ref="timeBox"
              style="width: 200px; font-size: 12px"
              :default-time="defaultStartTime"
            >
            </el-date-picker>
            至
            <el-date-picker
              v-model="ruleForm.enterEndTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              ref="timeBox"
              style="width: 200px; font-size: 12px"
              :picker-options="enterEndTimeOption"
              :default-time="defaultEndTime"
              :disabled="isStart"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="奖品设置：" required>
            <el-table
              :data="pointActivityPrizeDTOList"
              style="width: 700px; border: 1px solid #f0f0f0"
              :header-cell-style="{
                background: '#fafafa',
                'text-align': 'left',
              }"
              :cell-style="{ 'text-align': 'center' }"
            >
              <el-table-column label="奖品类型">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    style="width: unset;"
                    @click="centerVis(scope.row)"
                    :disabled="scope.row.prizeType == 14"
                    >{{ scope.row.title || "选奖品" }}</el-button
                  >
                </template>
              </el-table-column>
              <el-table-column label="值" width="80" prop="price">
              </el-table-column>
              <el-table-column label="奖品总数" width="180">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.totalAmount"
                    placeholder="请输入..."
                    style="width: 70px"
                    @input="
                      (val) => {
                        scope.row.totalAmount = val.replace(/^0|[^0-9]/g, '');
                      }
                    "
                    @blur="beAdd(scope.row)"
                    :disabled="
                      (activityData.isStart && !scope.row.minNum) ||
                        activityData.isStart
                    "
                  ></el-input>
                  份
                </template>
              </el-table-column>
              <el-table-column
                width="200"
                label="操作"
                v-if="activityData.isStart"
              >
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    v-if="scope.row.title"
                    @click="
                      itemAddNum('pointActivityPrizeDTOList', scope.$index)
                    "
                    >增加奖品数量</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <div class="newsInfo">曝光商品</div>
          <el-form-item label="曝光商品：">
            <div class="item-wrap">
              <el-checkbox
                v-model="ruleForm.isExposureItem"
                :true-label="1"
                :false-label="0"
                @change="exposureSwitchChange"
              >
                是否添加曝光商品
              </el-checkbox>
              <el-form :model="ruleForm" label-width="150px">
                <el-button
                  style="width: 155px; margin: 0 15px;display: inline-block;"
                  :class="[
                    { add_btn1: ruleForm.isExposureItem == 1 },
                    'zindexBox',
                  ]"
                  @click="exposureProducts"
                  :disabled="ruleForm.isExposureItem == 0"
                >
                  {{
                    itemList.length != 0
                      ? "添加曝光商品" + "(" + itemList.length + "/20" + ")"
                      : "添加曝光商品"
                  }}
                </el-button>
              </el-form>
              <el-radio-group
                v-model="priceType"
                :disabled="ruleForm.isExposureItem == 0"
              >
                <el-radio :label="0">显示京东价</el-radio>
              </el-radio-group>
            </div>
            <draggable
              v-if="itemList.length > 0"
              v-model="itemList"
              chosen-class="chosen"
              :scroll="true"
              animation="150"
              force-fallback="true"
              @start="isDragging = true"
              @end="onEnd"
              style="margin-top: 10px;background: rgba(38,112,251,0.06);padding: 10px;"
              filter=".unmover"
            >
              <transition-group type="transition">
                <div
                  v-for="(item, index) in itemList"
                  :key="item.skuId"
                  style="display: inline-block; position: relative"
                  class="show_upImg2"
                >
                  <img
                    :src="item.logo"
                    width="120px"
                    height="120px"
                    style="display: inline-block"
                  />&nbsp;
                  <div class="delectPosible">
                    <span class="delectSort">拖动排序</span>
                    <img
                      src="@/assets/thdImg/pages/delet.svg"
                      @click.stop="delec(index)"
                      class="delectIcom"
                    />
                  </div>
                </div>
              </transition-group>
            </draggable>
          </el-form-item>
          <div class="newsInfo">分享设置</div>
          <el-form-item label="小程序分享标题：" required>
            <el-input
              type="text"
              style="width: 400px;"
              show-word-limit
              v-model="ruleForm.shareTitle"
              :maxlength="28"
              :disabled="isStart"
            ></el-input>
          </el-form-item>
          <el-form-item label="小程序分享简介：" required>
            <el-input
              type="text"
              style="width: 400px;"
              show-word-limit
              v-model="ruleForm.shareIntroduce"
              :maxlength="28"
              :disabled="isStart"
            ></el-input>
          </el-form-item>
          <el-form-item label="小程序分享图片：" required>
            <div class="miniAppPic">
              <div class="top">
                <el-upload
                  class="upload"
                  action="/jd-hd-web/image/upload"
                  :show-file-list="false"
                  :before-upload="beforeUpload1"
                  :on-success="handleUpload1"
                  :disabled="isStart"
                >
                  <el-button size="mideal" class="returnBtn"
                    >自定义上传</el-button
                  >
                </el-upload>
                <el-button type="text" @click="picUrlReset1">重置</el-button>
              </div>
              <div class="bottom">
                <el-image class="elImg" :src="ruleForm.sharePic" fit="contain">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-plus"></i>
                  </div>
                </el-image>
                <div class="tips1">
                  <p>建议上传尺寸：200px * 200px</p>
                  <p>图片大小：300KB以内</p>
                  <p>格式：jpg、png</p>
                </div>
              </div>
            </div>
          </el-form-item>
          <div class="newsInfo">活动规则</div>
          <el-form-item label="规则内容:" required>
            <div style="width: 570px;">
              <richText
                v-model="ruleForm.ruleDescription"
                :readOnly="backgroundOpacity"
              ></richText>
            </div>
          </el-form-item>
          <div class="newsInfo">活动页悬浮按钮跳转链接设置</div>
          <el-form-item label="悬浮按钮图片：">
            <div class="miniAppPic">
              <div class="top">
                <el-upload
                  class="upload"
                  action="/jd-hd-web/image/upload"
                  :show-file-list="false"
                  :before-upload="beforeUpload2"
                  :on-success="handleUpload2"
                  :disabled="isStart"
                >
                  <el-button size="mideal" class="returnBtn"
                    >自定义上传</el-button
                  >
                </el-upload>
                <el-button type="text" @click="picUrlReset2">重置</el-button>
              </div>
              <div class="bottom">
                <el-image
                  class="elImg"
                  :src="ruleForm.jumpPicUrl"
                  fit="contain"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-plus"></i>
                  </div>
                </el-image>
                <div class="tips1">
                  <p>建议上传尺寸：150px * 150px</p>
                  <p>图片大小：100KB以内</p>
                  <p>格式：jpg、png、gif</p>
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="跳转链接：">
            <el-input
              type="text"
              style="width: 400px;"
              v-model="ruleForm.jumpLink"
              :disabled="isStart"
            ></el-input>
          </el-form-item>
          <actInfoSetting :valueRow="valueRow" :activityData="activityData" :isKeyActivity.sync="isKeyActivity" :placementPosition.sync="placementPosition"/>
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="!backgroundOpacity">
      <el-button
        class="returnBtn createBtn"
        @click="saveDraft"
        v-if="hasDraftBtn"
        >存为草稿</el-button
      >
      <template v-if="!valueRow || activityData.isCopy">
        <el-button
          class="keepBtn"
          type="primary"
          size="medium"
          @click="vaildForm"
          v-preventReClick
          >保存并开启活动</el-button
        >
      </template>
      <el-button
        v-else
        @click="vaildForm"
        class="keepBtn"
        type="primary"
        kai
        size="medium"
        >保存</el-button
      >
    </div>

    <!-- 添加曝光商品 -->
    <selectGoodsMonitor
      ref="selectGo"
      :isShow="selectGoodsVisible"
      @close="selectGoodsClose"
      :selectGoods="selectGoodsArr"
      :moduleType="true"
      :skuSearch="true"
      :xianz="true"
      :disabled="backgroundOpacity"
      :isSupportVirtualGroup="true"
    ></selectGoodsMonitor>

    <!-- 选择实物弹窗 -->
    <selectGoodsGift
      ref="selectGoodsGift"
      :echoDate="echoDate"
      @choose-shop="getTheData"
    >
    </selectGoodsGift>

    <!-- 保存并完成设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="tipsDialogVisible" width="800">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner"
        >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
      >
      <div slot="footer" class="dialog-footer">
        <el-button @click="tipsDialogVisible = false">取 消</el-button>
        <el-button
          @click="handleDialogCloseAnoth()"
          type="primary"
          :disabled="saveDisabled"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 增加奖品弹窗 -->
    <addPrizeNum
      :isShowAddNum="isShowAddNum"
      :prizeData="toAddItem"
      @confirm="confirmAdd"
      @close="isShowAddNum = false"
    />
  </div>
</template>

<script>
import selectGoodsGift from "./select_goodsGift";
import {
  addLockRight,
  modifyLockRight,
  getLockRight,
} from "@/api/paradiseAndTaskCommonController.js";
import { querymemberLevel } from "@/api/integralCenter/memberLevel";
import { updateCommon } from "@/api/integralCenter/integralTask";
import selectGoodsMonitor from "@/components/selectGoodsMonitor";
import draggable from "vuedraggable";
import richText from "@/components/richText.vue";
import addPrizeNum from "./components/add-prize-num.vue";

// ruleDTO 字段
const ruleKeyArr = [
  "picUrl",
  "lockEndTime",
  "lockStartTime",
  "point",
  "orderStartTime",
  "orderEndTime",
  "orderAmt",
  "finishStartTime",
  "finishEndTime",
  "enterStartTime",
  "enterEndTime",
  "shareTitle",
  "shareIntroduce",
  "sharePic",
  "jumpLink",
  "jumpPicUrl",
  "isolateActivityId",
  "moneyCountType",
];
export default {
  components: {
    selectGoodsGift,
    selectGoodsMonitor,
    draggable,
    richText,
    addPrizeNum,
  },
  props: {
    valueRow: {
      type: Object,
      default: () => {
        return null;
      },
    },
    activityData: {
      type: Object,
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
  },
  watch: {},
  data() {
    return {
      // 是否重点活动
      isKeyActivity: 0,
      // 活动投放位置
      placementPosition: [],
      echoDate: {},
      defaultStartTime: "00:00:00",
      defaultEndTime: "23:59:59",
      pickerOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 24 * 60 * 60 * 1000 + 1 ||
            time.getTime() >
              new Date(this.$store.getters.loginUserInfo.expiredIn).valueOf()
          );
        },
      },
      lockStartTimeOption: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 24 * 60 * 60 * 1000 + 1 ||
            (this.ruleForm.lockEndTime &&
              time.getTime() > new Date(this.ruleForm.lockEndTime).valueOf())
          );
        },
      },
      lockEndTimeOption: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 24 * 60 * 60 * 1000 + 1 ||
            (this.ruleForm.lockStartTime &&
              time.getTime() <
                new Date(this.ruleForm.lockStartTime).valueOf() -
                  24 * 60 * 60 * 1000 +
                  1) ||
            time.getTime() > new Date(this.ruleForm.endTime).valueOf()
          );
        },
      },
      orderStartTimeOption: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 24 * 60 * 60 * 1000 + 1 ||
            (this.ruleForm.orderEndTime &&
              time.getTime() > new Date(this.ruleForm.orderEndTime).valueOf())
          );
        },
      },
      orderEndTimeOption: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 24 * 60 * 60 * 1000 + 1 ||
            (this.ruleForm.orderStartTime &&
              time.getTime() <
                new Date(this.ruleForm.orderStartTime).valueOf() -
                  24 * 60 * 60 * 1000 +
                  1) ||
            time.getTime() > new Date(this.ruleForm.endTime).valueOf()
          );
        },
      },
      finishEndTimeOption: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 24 * 60 * 60 * 1000 + 1 ||
            (this.ruleForm.finishStartTime &&
              time.getTime() <
                new Date(this.ruleForm.finishStartTime).valueOf() +
                  24 * 60 * 60 * 1000 * 6 +
                  1) ||
            time.getTime() > new Date(this.ruleForm.endTime).valueOf()
          );
        },
      },
      enterEndTimeOption: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 24 * 60 * 60 * 1000 + 1 ||
            (this.ruleForm.enterStartTime &&
              time.getTime() <
                new Date(this.ruleForm.enterStartTime).valueOf() -
                  24 * 60 * 60 * 1000 +
                  1) ||
            time.getTime() > new Date(this.ruleForm.endTime).valueOf()
          );
        },
      },
      tipsDialogVisible: false, // 重要提示弹窗
      checked: false, //  是否明确活动规则 保存后弹窗内的勾选框
      // 表单规则
      rules: {
        // 表单规则校验
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
        ],
        allowLevel: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个",
            trigger: "change",
          },
        ],
        term: [{ required: true, message: "请填写抽奖条件", trigger: "blur" }],
        isLongTime: [
          { required: true, message: "请选择活动时间", trigger: "change" },
        ],
        ruleDescription: [
          { required: true, message: "请填写活动规则", trigger: "blur" },
        ],
      },
      // 表单数据
      ruleForm: {
        activityName: "",
        startTime: "",
        endTime: "",
        allowLevel: ["-1"], // 参与会员等级
        isExposureItem: 0, // 是否勾选曝光商品
        ruleDescription: "", // 活动规则

        /** 以下部分存在ruleDTO */
        lockStartTime: "", // 确权开始时间
        lockEndTime: "",
        point: null, // 确权积分
        orderStartTime: "", // 下单开始时间
        orderEndTime: "",
        orderAmt: "", // 下单累计金额
        finishStartTime: "", // 确认收货开始时间
        finishEndTime: "",
        enterStartTime: "", // 收货信息录入开始时间
        enterEndTime: "",
        picUrl: null, // c端活动背景图
        // 分享设置
        shareTitle: "",
        shareIntroduce: "",
        sharePic: "",
        jumpLink: "",
        jumpPicUrl: "",
        moneyCountType: 0, //金额统计规则
      },
      priceType: 0, // 显示京东价 不用传
      sharePic: "", // 重置后的分享图片地址
      jumpPicUrl:
        "https://jdminiapp.yucrm.cn/html/images/Proya/suspension_icon.png", // 重置后的按钮悬浮图片地址
      // 奖品列表
      pointActivityPrizeDTOList: [
        {
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: 3, // 类型 固定为实物
          price: null, // 价格
          title: "", // 商品标题
          totalAmount: null, // 总共奖品数量
          singleAmount: 1, // 单份奖品数量 固定为1
          logo: null, // 自定义商品图片
        },
      ],

      itemList: [], // 曝光商品列表
      selectGoodsVisible: false, //曝光商品弹窗
      selectGoodsArr: [], // 用于曝光商品回显
      isDragging: false, // 是否正在拖拽
      levelList: [], // 会员等级列表
      saveDisabled: false, // 保存按钮状态
      isStart: false,
      isDraft: false,
      toAddItem: null,
      isShowAddNum: false,
      toAddBelong: "",
      toAddIndex: 0,
    };
  },
  created() {
    console.log("当前玩法id", this.activityData.id);
    this.sharePic = this.getDefaultSharePic(this.activityData.id);
    this.ruleForm.sharePic = this.sharePic;
    this.ruleForm.jumpPicUrl = this.jumpPicUrl;
    this.ruleForm.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`;
    this.ruleForm.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`;
  },
  mounted() {
    this.getLevel();
    this.getDetail();
    console.log(this.invalidateDate);
    this.isStart = this.activityData.isStart ? true : false;
  },

  methods: {
    // 改变数量值
    confirmAdd(num) {
      let { toAddBelong, toAddIndex } = this;
      this[toAddBelong][toAddIndex].totalAmount = num;
      this.isShowAddNum = false;
    },
    // 获取相关数据打开弹窗
    itemAddNum(arrStr, index) {
      this.toAddItem = {
        ...this[arrStr][index],
        num: this[arrStr][index].totalAmount,
      };
      if (!this.toAddItem.title) {
        this.$message.error("没有奖品不能设置数量！");
        return;
      }
      this.toAddBelong = arrStr;
      this.toAddIndex = index;
      this.isShowAddNum = true;
    },
    beAdd(row) {
      console.log(row);
      if (this.isStart) {
        if (row.totalAmount < row.minNum && row.minNum) {
          row.totalAmount = row.minNum;
          this.$message.warning("为避免客诉，奖品数量不能小于之前哦~");
        }
      }
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      // console.log(nowDate,startDate);
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }
      // console.log(days);

      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },

    //曝光商品 删除
    delec(index) {
      this.itemList.splice(index, 1);
    },

    //图片拖拽
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
    },

    // 曝光商品回调
    selectGoodsClose(data) {
      console.log(data, 222);
      if (data) {
        this.itemList = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          this.itemList.push(fomeVaule);
        });
        this.selectGoodsArr = this.itemList;
      }
      this.selectGoodsVisible = false;
    },

    //添加曝光商品弹窗
    exposureProducts() {
      if (this.itemList.length == 0) {
        this.itemList = [];
      }
      this.selectGoodsArr = this.itemList;
      this.selectGoodsVisible = true;
      this.$refs.selectGo.handleRightCurrentChange(1);
    },

    // 是否添加曝光商品
    exposureSwitchChange(val) {
      if (!val) {
        this.itemList = [];
        this.selectGoodsArr = [];
      }
    },
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
        })
        .catch((res) => {});
    },
    //选中会员等级改变
    checkListchange(val) {
      val.forEach((low) => {
        if (low == -1) {
          this.ruleForm.allowLevel = ["-1"];
        }
      });
    },
    //输入框限制负数
    checkputn(value, key) {
      let filtered = value.replace(/[^0-9]/g, "");
      console.log(filtered);
      if (filtered.indexOf(0) == 0) {
        filtered = "";
      }
      this.ruleForm[key] = filtered;
      return filtered;
    },

    //打开 选择实物奖品 弹窗
    centerVis(row) {
      if (this.isStart) return;
      this.echoDate = row;
      this.$refs.selectGoodsGift.openDialog();
    },

    // 获取奖品
    getTheData(data, prizeType) {
      console.log(data, prizeType, 2233);
      this.pointActivityPrizeDTOList[0].assetsId = data.skuId;
      this.pointActivityPrizeDTOList[0].price = Number(data.discount);
      this.pointActivityPrizeDTOList[0].title = data.name;
      this.pointActivityPrizeDTOList[0].logo = data.logo;
    },
    // 返回
    returnBack() {
      this.$emit("returnBack");
    },
    //深拷贝
    deepClone(obj) {
      let theObj = JSON.stringify(obj),
        objClone = JSON.parse(theObj);
      return objClone;
    },

    // 保存
    vaildForm() {
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.endTime) {
        this.$message.warning("请输入活动结束时间");
        return;
      }
      let nowTime = new Date().getTime();
      let end = new Date(this.ruleForm.endTime).valueOf();
      if (end < nowTime) {
        this.$message.warning("结束时间不能小于当前时间");
        return;
      }
      //活动C端背景图
      if (!this.ruleForm.picUrl) {
        this.$message.warning("请上传活动C端背景图");
        return;
      }
      //确权时间：
      if (!this.ruleForm.lockStartTime || !this.ruleForm.lockEndTime) {
        this.$message.warning("请输入确权时间");
        return;
      }
      if (!this.activityData.isStart) {
        if (
          new Date(this.ruleForm.lockStartTime).valueOf() <
            new Date().getTime() ||
          new Date(this.ruleForm.lockEndTime).valueOf() < new Date().getTime()
        ) {
          this.$message.warning("确权时间不能小于当前时间");
          return;
        }
      }
      //确权积分：
      if (!this.ruleForm.point) {
        this.$message.warning("请输入确权积分");
        return;
      }
      //下单时间：
      if (!this.ruleForm.orderStartTime || !this.ruleForm.orderEndTime) {
        this.$message.warning("请输入下单时间");
        return;
      }
      if (!this.activityData.isStart) {
        if (
          new Date(this.ruleForm.orderStartTime).valueOf() <
            new Date().getTime() ||
          new Date(this.ruleForm.orderEndTime).valueOf() < new Date().getTime()
        ) {
          this.$message.warning("下单时间不能小于当前时间");
          return;
        }
      }
      //下单累计金额：
      if (!this.ruleForm.orderAmt) {
        this.$message.warning(
          "请输入下单" +
            (this.ruleForm.moneyCountType ? "单笔金额" : "累计金额")
        );
        return;
      }
      //确认收货时间：
      if (!this.ruleForm.finishStartTime || !this.ruleForm.finishEndTime) {
        this.$message.warning("请输入确认收货时间");
        return;
      }
      //收货信息录入时间：
      if (!this.ruleForm.enterStartTime || !this.ruleForm.enterEndTime) {
        this.$message.warning("请输入收货信息录入时间");
        return;
      }
      if (!this.activityData.isStart) {
        if (
          new Date(this.ruleForm.finishStartTime).valueOf() <
            new Date().getTime() ||
          new Date(this.ruleForm.finishEndTime).valueOf() < new Date().getTime()
        ) {
          this.$message.warning("确认收货时间不能小于当前时间");
          return;
        }
      }
      if (!this.activityData.isStart) {
        if (
          new Date(this.ruleForm.enterStartTime).valueOf() <
            new Date().getTime() ||
          new Date(this.ruleForm.enterEndTime).valueOf() < new Date().getTime()
        ) {
          this.$message.warning("收货信息录入时间不能小于当前时间");
          return;
        }
      }
      // 奖品信息
      if (!this.pointActivityPrizeDTOList[0].logo) {
        this.$message.warning("请设置奖品信息！");
        return;
      }
      //奖品总数
      if (!this.pointActivityPrizeDTOList[0].totalAmount) {
        this.$message.warning("请输入奖品总数");
        return;
      }
      //曝光商品
      if (this.ruleForm.isExposureItem && this.itemList.length == 0) {
        this.$message.warning("请选择曝光商品！");
        return;
      }
      // 小程序分享标题
      if (!this.ruleForm.shareTitle) {
        this.$message.warning("请输入小程序分享标题");
        return;
      }
      // 小程序分享简介
      if (!this.ruleForm.shareIntroduce) {
        this.$message.warning("请输入小程序分享简介");
        return;
      }
      // 活动规则
      if (
        !this.ruleForm.ruleDescription ||
        this.ruleForm.ruleDescription == "<p><br></p>"
      ) {
        this.$message.warning("请输入活动规则");
        return;
      }
      if(this.placementPosition.length==0) {
        this.$message.warning("请选择活动投放位置！");
        return
      }

      this.tipsDialogVisible = true;
    },
    // 保存草稿
    saveDraft() {
      //活动名称的限制
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if (this.isDraftEdit) {
        this.$confirm("是否保存对当前草稿的修改?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      } else {
        this.$confirm("是否存为草稿?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      }
    },
    // 保存提示框确认
    async handleDialogCloseAnoth() {
      let ruleDTO = {};
      ruleKeyArr.forEach((item) => {
        ruleDTO[item] = this.ruleForm[item];
      });
      let obj = {};

      obj.activityName = this.ruleForm.activityName;
      obj.startTime = this.ruleForm.lockStartTime; // 活动开始时间 使用 确权开始时间
      obj.endTime = this.ruleForm.endTime;
      obj.allowLevel = this.ruleForm.allowLevel.join(","); //参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
      obj.isExposureItem = this.ruleForm.isExposureItem;
      obj.ruleDescription = this.ruleForm.ruleDescription;
      // 是否重点活动
      obj.isKeyActivity = this.isKeyActivity;
      obj.placementPosition = this.placementPosition.join(",");


      obj.ruleDTO = ruleDTO; // 活动规则
      obj.pointActivityPrizeDTO = this.pointActivityPrizeDTOList[0]; // 活动奖品
      obj.itemList = this.itemList; //曝光商品集合
      let _this = this;
      if (this.checked == true || this.isDraft) {
        this.saveDisabled = true;
        if (
          !this.valueRow ||
          this.activityData.isCopy ||
          this.isDraft ||
          this.isDraftEdit
        ) {
          if (this.isDraft) {
            obj.status = 5;
          }
          // 草稿箱编辑-添加活动id
          if (this.isDraftEdit) {
            obj.id = this.valueRow.id;
          }
          if (this.activityData.isCopy) {
            delete obj.id;
          }
          addLockRight(obj)
            .then((res) => {
              if (res && res.code == 1) {
                if (this.isDraft) {
                  this.$message.success("保存成功！");
                  this.$emit("returnBack", true);
                } else {
                  this.tipsDialogVisible = false;
                  // let routeUrl = this.$router.resolve({
                  //   path: "/integralCenter/integralEden",
                  //   query: { tabAct: 3 },
                  // });
                  // window.open(routeUrl.href, "_self");
                  this.$router.push({
                    name: "lock_auth_throw",
                    query: {
                      id: res.data.id,
                      activityType: res.data.activityType,
                      isEdit: false,
                    },
                  });
                  this.$message.success(res.message);
                }
              } else {
                this.$message.error(res.message);
              }
              this.saveDisabled = false;
            })
            .catch((res) => {
              this.saveDisabled = false;
              console.log("error", err);
            });
        } else {
          obj.pointActivityId = this.valueRow.id;
          let res;
          if (this.activityData.isStart) {
            let params = {
              activityId: this.valueRow.id,
              // endTime: obj.endTime,
              ruleDescription: obj.ruleDescription,
              prizes: {
                prizeId: obj.pointActivityPrizeDTO.id,
                totalAmount: obj.pointActivityPrizeDTO.totalAmount,
              },
              isExposureItem: this.ruleForm.isExposureItem,
              itemList: this.itemList,
            };
            res = await updateCommon(params);
          } else {
            res = await modifyLockRight(obj);
          }
          // modifyLockRight(obj)
          //   .then((res) => {
          if (res && res.code == 1) {
            this.tipsDialogVisible = false;
            this.$router.push({
              name: "lock_auth_throw",
              query: {
                id: res.data.id,
                activityType: res.data.activityType,
                isEdit: true,
              },
            });
            this.$message.success(res.message);
          } else {
            // putOne 会多一层data
            if (res.message) {
              this.$message.error(res.message);
            } else {
              this.$message.error(res.data.message);
            }
          }
          this.saveDisabled = false;
          // })
          // .catch((err) => {
          // });
        }
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    forceUpdate() {
      this.$forceUpdate();
    },
    //获取活动详情
    getDetail() {
      if (this.valueRow) {
        let id = this.valueRow.id;
        getLockRight(id)
          .then((res) => {
            let obj = res.data;

            this.ruleForm.activityName = obj.activityName;
            this.ruleForm.startTime = obj.startTime; // 活动开始时间 使用 确权开始时间
            this.ruleForm.endTime = obj.endTime;
            this.ruleForm.allowLevel = res.data.allowLevel.split(",");
            this.ruleForm.isExposureItem = Number(obj.isExposureItem);
            this.ruleForm.picUrl = obj.ruleDto.picUrl;
            this.ruleForm.isolateActivityId = obj.ruleDto.isolateActivityId;
            // 参与规则设置
            ruleKeyArr.forEach((item) => {
              // 旧数据兼容
              if (item == "moneyCountType") {
                this.ruleForm[item] = obj.ruleDto[item] || 0;
              } else {
                this.ruleForm[item] = obj.ruleDto[item];
              }
            });
            if (!this.activityData.isCopy) {
              this.ruleForm.ruleDescription = obj.ruleDescription; // 规则设置
              // 奖品设置
              let prizeObj = obj.pointActivityPrizeDTO;
              this.pointActivityPrizeDTOList[0].id = prizeObj.id;
              this.pointActivityPrizeDTOList[0].assetsId = prizeObj.assetsId; // 资产项id(计划id优惠卷id商品id)
              this.pointActivityPrizeDTOList[0].prizeType = 3; // 类型 固定为实物
              this.pointActivityPrizeDTOList[0].price = prizeObj.price; // 价格
              this.pointActivityPrizeDTOList[0].title = prizeObj.title; // 商品标题
              this.pointActivityPrizeDTOList[0].logo = prizeObj.logo; // 自定义商品图片
              this.pointActivityPrizeDTOList[0].totalAmount = prizeObj.totalAmount
                ? Number(prizeObj.totalAmount)
                : null; // 总共奖品数量
              this.pointActivityPrizeDTOList[0].minNum = prizeObj.totalAmount
                ? Number(prizeObj.totalAmount)
                : null; // 总共奖品数量
              this.pointActivityPrizeDTOList[0].singleAmount =
                prizeObj.singleAmount; // 单份奖品数量 固定为1
            }

            this.selectGoodsArr = res.data.itemList || [];
            this.itemList = res.data.itemList || [];
            this.isKeyActivity = res.data.isKeyActivity || 0;
            this.placementPosition = res.data.placementPosition.split(",") || ["SHOP"];
          })
          .catch((res) => {});
      } else {
      }
    },

    //上传图片前校验   背景图
    beforeUpload(file) {
      let _this = this;
      let image = new Image();
      let _URL = window.URL || window.webkitURL;
      image.onload = function() {
        // const valid = image.width == 750 && image.height == 1550; 不校验尺寸
        const valid = true;
        file.isFlag = valid;

        console.log(valid);
        if (valid) {
        } else {
          _this.$message.info("图片尺寸不符合要求，请重新上传");

          return false;
        }
      };
      image.src = _URL.createObjectURL(file);
      console.log(file);
      const isLt3M = file.size < 1024 * 300;
      if (!isLt3M) {
        this.$message.info("图片大小不符合要求，请重新上传");
        return false;
      }
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];

      if (sorts.indexOf(type) < 0) {
        this.$message.info("图片格式不符合要求，请重新上传");
        return false;
      }
    },
    // 上传成功  背景图
    handleUpload(res) {
      if (res.code != 1) {
        this.$message.error(res.messaga);
      } else {
        this.ruleForm.picUrl = res.data;
      }
    },
    // 重置分享图片  背景图
    picUrlReset() {
      this.ruleForm.picUrl = null;
    },

    //上传图片前校验   分享设置
    async beforeUpload1(file) {
      let _this = this;
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];

      if (sorts.indexOf(type) < 0) {
        this.$message.info("图片格式不符合要求，请重新上传");
        await Promise.reject();
        return false;
      }
      await this.imgchecked(file);
      console.log(file);
      const isLt3M = file.size < 1024 * 300;
      if (!isLt3M) {
        this.$message.info("图片大小不符合要求，请重新上传");
        await Promise.reject();
        return false;
      }
    },
    // 上传成功  分享设置
    handleUpload1(res) {
      if (res.code != 1) {
        this.$message.error(res.messaga);
      } else {
        this.ruleForm.sharePic = res.data;
      }
    },
    // 重置分享图片  分享设置
    picUrlReset1() {
      if (this.activityData.isStart) return;
      this.ruleForm.sharePic = this.sharePic;
    },

    //上传图片前校验   悬浮按钮设置
    async beforeUpload2(file) {
      let _this = this;
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg", ".gif"];

      if (sorts.indexOf(type) < 0) {
        this.$message.info("图片格式不符合要求，请重新上传");
        await Promise.reject();
        return false;
      }
      await this.imgchecked(file, 150, 150);
      console.log(file);
      const isLt3M = file.size < 1024 * 100;
      if (!isLt3M) {
        this.$message.info("图片大小不符合要求，请重新上传");
        await Promise.reject();
        return false;
      }
    },

    // 上传成功  悬浮按钮设置
    handleUpload2(res) {
      if (res.code != 1) {
        this.$message.error(res.messaga);
      } else {
        this.ruleForm.jumpPicUrl = res.data;
      }
    },

    // 重置分享图片  悬浮按钮设置
    picUrlReset2() {
      if (this.activityData.isStart) return;
      this.ruleForm.jumpPicUrl = this.jumpPicUrl;
    },

    //判断尺寸方法 默认200*200
    imgchecked(file, width = 200, height = 200) {
      let _this = this;
      return new Promise((resolve, reject) => {
        let image = new Image();
        let _URL = window.URL || window.webkitURL;
        image.onload = function() {
          const valid = image.width == width && image.height == height;
          file.isFlag = valid;

          console.log(valid);
          if (valid) {
            console.log("Image loaded");
            resolve();
          } else {
            _this.$message.info("图片尺寸不符合要求，请重新上传");
            reject();
          }
        };
        image.src = _URL.createObjectURL(file);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.item-wrap {
  display: flex;
  align-items: center;
}
.createPlayStep {
  min-width: 800px;
  position: relative;
  box-sizing: border-box;
  min-height: 80vh;
  background-color: #fff;
  border-radius: 6px;
  margin: -24px;
  margin-bottom: 24px;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      color: #333;
      cursor: default;
    }
  }
  .step {
    padding: 30px 24px 0;
    .bz {
      display: flex;
      justify-content: center;
      height: 18px;
      // border-bottom: 1px solid #f3f3f3;
    }
  }
  .firststep {
    min-height: 720px;
    box-sizing: border-box;
    padding: 35px 35px 0;
    .itemList {
      display: flex;
      .item {
        box-sizing: border-box;
        position: relative;
        color: #666;
        text-align: center;
        padding: 6px;
        &:hover {
          .border::before,
          .border::after {
            opacity: 1;
            transform: scale(1);
          }
        }
        .border {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          border-radius: 4px;
          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }
          &::before {
            border-top: 1px solid #7b61ff;
            border-bottom: 1px solid #7b61ff;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }
          &::after {
            border-right: 1px solid #7b61ff;
            border-left: 1px solid #7b61ff;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }
        .wrapper {
          position: relative;
          height: 350px;
          border-radius: 6px;
          overflow: hidden;
          width: 206px;
          &:hover {
            .mask {
              opacity: 1;
            }
          }
          .mask {
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            opacity: 0;
            transition: all 0.2s;
            .img {
              max-width: 130px;
              margin: 0 auto 30px;
              .imgBg {
                box-sizing: border-box;
                height: 129px;
                width: 129px;
                padding: 6px;
                border-radius: 6px;
                background-color: #fff;
              }
              .tpl {
                display: inline-block;
                margin-top: 4px;
                opacity: 0.7;
              }
            }
          }
        }
      }
    }
  }
  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 0px 28px 1px 24px;
    margin-bottom: 29px;
    .zd {
      width: 360px;
    }
    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .limit {
      display: flex;
      flex-direction: column;
      p {
        margin: 0;
        &:nth-child(2) {
          margin: 16px 0;
        }
      }
      .c {
        color: #7b61ff;
      }
      .desc {
        i {
          opacity: 0.7;
          color: #7b61ff;
        }
        color: #999;
      }
      /deep/ .el-input {
        margin: 0 6px;
      }
    }
    .img {
      display: inline-block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #eeeeee;
    }
    .tips {
      display: flex;
      flex-direction: column;
      margin-top: 16px;
      box-sizing: border-box;
      padding: 13px 30px;
      background: #fffaee;
      font-size: 13px;
      color: #333;
      i {
        color: #fe8f8a;
        opacity: 0.7;
      }
      p {
        margin: 0;
        line-height: 20px;
        padding-left: 18px;
      }
    }
    .generate {
      width: 76px;
      margin-top: 8px;
      background: rgba(127, 133, 233, 0.1);
      border: 1px solid rgba(127, 133, 233, 1);
      color: #7f85e9;
    }
    .termAdd {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 6px;
      color: #333;
      p {
        margin: 0;
      }
      .add {
        margin-left: 4px;
        color: #7b61ff;
      }
    }
    .set {
      display: inline-block;
      margin-top: 30px;
    }
    .desc {
      margin-left: 20px;
      color: #999;
      font-size: 13px;
      i {
        color: #fe8f8a;
        opacity: 0.7;
        font-size: 13px;
      }
    }
    .s {
      color: #7b61ff;
      cursor: pointer;
    }
    .returnBtn {
      width: 148px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid #7b61ff;
      color: #7b61ff;
      transition: all 0.2s;
      &:hover {
        background-color: #7b61ff;
        color: #fff;
      }
    }
    .keepBtn {
      margin-left: 30px;
      width: 188px;
      background-color: #7b61ff;
      color: #fff;
      transition: all 0.2s;
      &:hover {
        opacity: 0.9;
      }
    }
    /deep/ .el-table .el-table__header-wrapper th .cell {
      text-align: center;
      font-weight: 500;
    }
    /deep/ .el-table .el-table__header-wrapper th {
      border-right: 1px solid #f0f0f0;
      &:last-child {
        border-right: none;
      }
    }
    /deep/ .el-table--enable-row-transition .el-table__body td {
      text-align: center;
      border-right: 1px solid #f0f0f0;
      &:last-child {
        border-right: none;
      }
    }
  }
}
.wrapper-kaika {
  width: 100%;
  height: 100%;
  display: grid;
  // align-items: center;
  // justify-content: center;

  .wrapper-kaika-img {
    background-color: #fafafa;
    border: 2px solid rgba(254, 77, 69, 0.0784313725490196);
    border-radius: 8px;
    height: 350px;
    // margin-right: 20px;
    position: relative;
    &:hover {
      .borderkaika::before,
      .borderkaika::after {
        opacity: 1;
        transform: scale(1);
      }
    }
    .borderkaika {
      position: absolute;
      left: -6px;
      top: -6px;
      width: 218px;
      height: 360px;
      border-radius: 4px;
      &::before,
      &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        content: "";
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.8s, transform 0.8s;
        border-radius: 4px;
      }
      &::before {
        border-top: 1px solid #7b61ff;
        border-bottom: 1px solid #7b61ff;
        -webkit-transform: scale(0, 1);
        transform: scale(0, 1);
      }
      &::after {
        border-right: 1px solid #7b61ff;
        border-left: 1px solid #7b61ff;
        -webkit-transform: scale(1, 0);
        transform: scale(1, 0);
      }
    }

    div {
      font-size: 18px;
      font-weight: bold;
      // line-height: 25px;
      color: #333333;
    }
    img {
      width: 32px;
      height: 32px;
    }

    .queryIdIMG {
      display: none;
    }
    &:hover {
      .queryIdIMG {
        display: block;
      }
      .mask {
        opacity: 1;
      }
    }
    .mask {
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.6);
      color: #fff;
      opacity: 0;
      transition: all 0.2s;
      .img {
        max-width: 130px;
        margin: 0 auto 30px;
        .imgBg {
          box-sizing: border-box;
          height: 129px;
          width: 129px;
          padding: 6px;
          border-radius: 6px;
          background-color: #fff;
        }
        .tpl {
          display: inline-block;
          font-size: 14px;
          color: #fff;
          margin-top: 10px;
          // opacity: 0.7;
        }
      }
    }
  }
  .wrapper-kaika-tanchuang {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .lijijq {
    &::after {
      content: "立即领取";
      display: block;
      position: absolute;
      bottom: 9px;
      left: 51%;
      transform: translateX(-50%);
      font-size: 14px;
      font-family: system-ui;
      font-weight: bold;
      color: #ed6e09;
      text-shadow: 0 0 black;
    }
  }
}
.miniAppPic {
  position: relative;
  .image-slot {
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    text-align: center;
    padding-top: 43px;
    i {
      font-size: 30px;
      color: #909399;
    }
  }
  .top {
    position: relative;
    left: 0px;
    display: flex;
    .returnBtn {
      border-radius: 4px;
      width: auto;
      height: 32px;
      line-height: 32px;
      text-align: center;
      color: #7b61ff;
      background: rgba(123, 97, 255, 0.1);
      border: 1px solid #7b61ff;
      &:hover {
        color: #fff;
        background: #7b61ff;
      }
    }
    .reset {
      // color: #7b61ff;
      cursor: pointer;
      font-size: 14px;
      margin-left: 15px;
    }
  }
  .bottom {
    position: relative;
    top: 15px;
    .elImg {
      width: 120px;
      height: 120px;
      border: 1px dashed #dddddd;
      border-radius: 5px;
    }
    .tips1 {
      position: absolute;
      left: 135px;
      top: 22px;
      line-height: 2;
      color: #aaaaaa;
      font-size: 13px;
    }
  }
}

/deep/ .createPlayStep {
  .textarea {
    .el-textarea__inner {
      min-height: 120px !important;
    }
  }
  .el-step__main {
    position: absolute;
    top: -7px;
    left: 33px;
  }
  .el-step__head.is-process {
    position: absolute;
  }
  .el-step.is-horizontal .el-step__line {
    left: 107px;
    right: 15px;
  }
  .el-step {
    position: relative;
  }
}
</style>
